module.exports = __webpack_public_path__ + "static/img/baimizhou.c923b91b.png";